// extracted by mini-css-extract-plugin
export default {"main":"BookCard_main__ZFQYP","category":"BookCard_category__-p27E"};